"use client";

import { isNil } from "lodash";
import { useTranslations } from "next-intl";

import Button from "@/components/ui/button";
import { useAuth } from "@/contexts/auth_context";
import { useModal } from "@/contexts/modal_context";
import { Tournament } from "@/types/projects";
import { getProjectSlug } from "@/utils/navigation";

type Props = {
  tournament: Tournament;
};

const PredictionFlowButton: React.FC<Props> = ({ tournament }) => {
  const t = useTranslations();
  const { user } = useAuth();
  const { setCurrentModal } = useModal();

  const isForecastsFlowEnabled =
    tournament.forecasts_flow_enabled &&
    !tournament.timeline.all_questions_closed;

  if (!isForecastsFlowEnabled || isNil(user) || user.is_bot) {
    return null;
  }

  return (
    <Button
      onClick={() => {
        if (isNil(user)) {
          setCurrentModal({ type: "signin" });
        }
      }}
      href={
        !isNil(user)
          ? `/tournament/${getProjectSlug(tournament)}/prediction-flow`
          : undefined
      }
      className="w-full flex-1 border-blue-400 text-sm text-blue-700 dark:border-blue-400-dark dark:text-blue-700-dark md:text-lg"
    >
      {t("predictionFlow")}
    </Button>
  );
};

export default PredictionFlowButton;
